module.exports = __webpack_public_path__ + "img/arrow.f7f2bad1.png";